// extracted by mini-css-extract-plugin
module.exports = {"results":"Results-module__results___1G7mB","results--filtersOpen":"Results-module__results--filtersOpen___28v1G"};